import axios from 'axios';
import Layout from '../shared/Layout';
import { useContext, useEffect, useRef, useState } from 'react';

import language from '../../variables/language';
import { useLocation, Link , useNavigate, useParams } from 'react-router-dom';
import Form from '../../components/forms/Form';
import PipeCreatorContainer from './PipeCreatorContainer';
import FunctionalHeader from '../../components/func panel/FunctionalHeader';
import Function from '../../components/func panel/Function';
import IconFilter from '../../components/icons/IconFilter';
import IconAdd from '../../components/icons/IconAdd';
import SearchForm from '../../components/forms/SearchForm';
import IconGoBack from '../../components/icons/IconGoBack';
import IconAddFolder from '../../components/icons/IconAddFolder';
import IconAddColumn from '../../components/icons/IconAddColumn';

const PipelineCreator = () => {
  const label = 'clients';
  const url = '/api/stages';
  const urlPipeline = '/api/stage-types';
  const { id } = useParams();
  const [modalState ,setModalState] = useState('none');
  const [refresh, setRefresh] = useState(0);

  const navigate = useNavigate();

  const [stageType, setStageType] = useState(id);
  const [params, setParams ] = useState('?stageType='+stageType);
  const [searchParameters , setSearchParameters] = useState('');
  const [searchInput , setSearchInput] = useState('');
  const [returnedData, setReturnedData] = useState({});
  const [urlFinal, setUrlFinal] = useState(url+params+searchParameters) ;


    const [headerHeight , setHeaderHeight] = useState(0);
    const elementRef = useRef(null);
    const elementRef2 = useRef(null);
    const elementRef3 = useRef(null);
   const [lisRefresh, setLisRefresh] = useState(0);
  const [headerContainer , setHeaderContainer] = useState(0);

  const [inputsStage, setInputsStage] = useState(
    {
        'name':{'name':'name','type' : 'text','tagtype' : 'input','value' : '','disabled':false,'width':'39%'},
        'color':{'name':'color','type' : 'color','tagtype' : 'input','value' : '','disabled':false,'width':'19%'},
        'stagetype':{'name':'stagetype','type' : 'number','tagtype' : 'select','url':'/api/stage-types','value' : stageType,'disabled':false,'width':'29%'},
    });
  const [inputsPipeline, setInputsPipeline] = useState(
    {
        'name':{'name':'name','type' : 'text','tagtype' : 'input','value' : '','disabled':false,'width':'79%'},
    });

    const [inputsSearch, setInputsSearch] = useState(
      {
          'stageType':{'name':'stageType','type' : 'number','tagtype' : 'select','url':'/api/stage-types','value' : '','disabled':false,'width':'19%'},
      });

    const stateHundler = (state, id, client) => {
      if(state === 'edit'){
        setModalState('edit');
      }else if(state === 'none'){
        setModalState('none');
      }else if(state === 'menu'){
        setModalState('menu');
      }
    }
    const onRefreshHundler = ()=> {
      if(refresh==="1"){
        setRefresh('0');
      }else{
        setRefresh('1');
      }
    }
    const stopHund = (e) => {
      e.stopPropagation();
      console.log("sdsd");
    }



   const onListRefreshHundler = ()=> {
     if(lisRefresh==="1"){
      setLisRefresh('0');
     }else{
      setLisRefresh('1');
     }
     if(modalState !== 'menu'){
      onRefreshHundler();
     }
    
   }
   useEffect(()=>{

    setStageType(id)
    console.log('INITIALIZATIONE ONCE!!!!!!',id);

    })

    const doneFunctionAddedStageType = (data) => {
      if (data && data.id) {
        setStageType(data.id)
        setInputsStage({
            'name':{'name':'name','type' : 'text','tagtype' : 'input','value' : '','disabled':false,'width':'39%'},
            'color':{'name':'color','type' : 'color','tagtype' : 'input','value' : '','disabled':false,'width':'19%'},
            'stagetype':{'name':'stagetype','type' : 'number','tagtype' : 'select','url':'/api/stage-types','value' : data.id,'disabled':false,'width':'29%'},
        })
        setInputsSearch({
            'stageType':{'name':'stageType','type' : 'number','tagtype' : 'select','url':'/api/stage-types','value' : data.id,'disabled':false,'width':'19%'},
        })
        navigate("/pipeline-creator/"+data.id);
        setSearchParameters('stageType='+data.id);
        onRefreshHundler();
      }
      
    }

      useEffect(()=>{
        if (returnedData && returnedData.stageType) {
            navigate("/pipeline-creator/"+returnedData.stageType);
        }
        console.log('urlFinal brfotr',urlFinal);
        if (searchParameters && searchParameters.includes('undefined')) {
            setSearchParameters( searchParameters.replace('undefined',id));
        }
        if (urlFinal && urlFinal.includes('undefined')) {
           setUrlFinal( urlFinal.replace('undefined',stageType));
        }
        if(searchParameters && !searchParameters.includes('undefined')) {
          setUrlFinal( url + '?'+ searchParameters);
        } 
        console.log('urlFinal after',urlFinal);
      },[searchParameters]);




        useEffect(()=>{
        if (headerHeight=== 1 &&  elementRef.current) {
          setHeaderContainer( elementRef.current.offsetHeight +48);
        }else if(headerHeight=== 2 &&  elementRef2.current){
          setHeaderContainer( elementRef2.current.offsetHeight +48);
        } else if(headerHeight=== 3 &&  elementRef3.current){
          setHeaderContainer( elementRef3.current.offsetHeight +48);
        }else{
          setHeaderContainer('fit-content');
        }
      
      },[headerHeight,lisRefresh]);



  return (
    <Layout>
      <FunctionalHeader height={headerContainer}  name={language[language.lang]["pipeline creator"]} >

            <Function num={1} icon={<IconFilter/>} heightHundler={setHeaderHeight}  headerHeight={headerHeight} >
              <div key={1} ref={elementRef} style={{display:'flex',flexDirection:'row'}} >
                <SearchForm  setSearchParameters={setSearchParameters}  inputs={inputsSearch}  setReturnedData={setReturnedData}
                onRefreshHundler={onRefreshHundler} name={language[language.lang].modals[label].createTitle}></SearchForm>
                
              </div>
            </Function>

            <Function num={2} icon={<IconAddFolder fillColor={'search-icon'}/>} heightHundler={setHeaderHeight}  headerHeight={headerHeight} >
              <div key={2}  ref={elementRef2} >
                <Form   inputs={inputsPipeline}  url={urlPipeline} onRefreshHundler={onRefreshHundler} doneFunction={doneFunctionAddedStageType}
                name={language[language.lang].modals[label].createTitle}></Form>
              </div>
            </Function>
            <Function num={3} icon={<IconAddColumn fillColor={'search-icon'}/>} heightHundler={setHeaderHeight}  headerHeight={headerHeight} >
              <div key={3}  ref={elementRef3} >
                <Form   inputs={inputsStage} key={urlFinal} url={url} onRefreshHundler={onListRefreshHundler} 
                name={language[language.lang].modals[label].createTitle}></Form>
              </div>
            </Function>
            <Function num={4} icon={<IconGoBack fillColor={'search-icon'}  onClick={(e) => { e.stopPropagation();
                                                                        navigate("/pipeline/"+stageType);
                                                                      }}/>} 
              heightHundler={setHeaderHeight}  headerHeight={headerHeight} >

            </Function>
      </FunctionalHeader>

    <main className='main-block'  >
      <div className='main-content txt-c'  style={{overflowY:'visible'}}>
        { stageType  ?  <PipeCreatorContainer key={urlFinal}  stateHundler={stateHundler} url={urlFinal}
         refresh={refresh} onRefreshHundler={onRefreshHundler}/> 
         : 
         ('Stage type have not chosen')}


      </div>  

    </main>

  </Layout>
  )
}

export default PipelineCreator